import React, {Component} from 'react';
import {connect} from 'react-redux';

import OwnerDashboard from '../owner/OwnerDashboard';
import TenantDashboard from '../tenant/dashboard/TenantDashboard';
import {setFooterVisibility, setNavbarVisibility} from "../navigation/actions/navbar";

class DashboardContainer extends Component {
    componentWillMount() {
        this.props._setFooterVisibility(true);
        this.props._setNavbarVisibility(true);
    }

    render() {
        let dash;

        if (this.props.user_type === 'tenant') {
            dash = (<TenantDashboard/>);
        } else if (this.props.user_type === 'landlord') {
            dash = (<OwnerDashboard/>);
        } else {
            dash = null;
        }

        return dash;
    }
}

const mapStateToProps = (state) => ({
    user_type: state.activeUser.user_type,
    isLoading: state.display.isLoading
});

const mapDispatchToProps = (dispatch) => ({
    _setNavbarVisibility(visible) {
        return dispatch(setNavbarVisibility(visible));
    },
    _setFooterVisibility(visible) {
        return dispatch(setFooterVisibility(visible));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardContainer);


// WEBPACK FOOTER //
// ./src/containers/dashboards/DashboardContainer.js